import {
  availableLoadTypes,
  optionLabel,
} from "@/components/maps/carRouteOptions"
import { MultiSelect } from "@/components/ui/multi-select"
import { useTranslation } from "react-i18next"
import { LoadType } from "@/api/adHocCommands"
import { useEffect, useMemo, useState } from "react"

export default function LoadTypeSelect({
  onClose,
  initialSelected = [],
}: {
  onClose: (selectedOptions: LoadType[]) => void
  initialSelected?: LoadType[]
}) {
  const { t } = useTranslation()
  const [selectedOptions, setSelectedOptions] =
    useState<LoadType[]>(initialSelected)

  // Update internal state when initialSelected changes
  useEffect(() => {
    setSelectedOptions(initialSelected)
  }, [initialSelected])

  const options = useMemo(
    () =>
      availableLoadTypes.map((option) => ({
        ...option,
        label: optionLabel(t, option),
      })),
    [t],
  )

  return (
    <MultiSelect
      options={options}
      selected={selectedOptions}
      onClose={onClose}
      onChange={setSelectedOptions}
      placeholder={t("orders.transportOrder.loadType")}
    />
  )
}
